import PropTypes from 'prop-types';

import { Modal, ModalHeader, ModalBody } from '@spotahome/ui-library';

const ListingTagModal = ({ isOpen, onRequestClose, children }) => (
  <Modal
    isOpen={isOpen}
    size="medium"
    contentLabel="modal"
    ariaHideApp={false}
    onRequestClose={onRequestClose}
  >
    <ModalHeader
      onRequestClose={onRequestClose}
      dataText="listing-tag-modal-close-button"
    />
    <ModalBody>{children}</ModalBody>
  </Modal>
);

ListingTagModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default ListingTagModal;
